export default __webpack_public_path__ + "static/02-47b409e0471a1fec922b0590f8d1364c.png";